import {
  Datagrid,
  TextField,
  List,
  EditButton,
} from "react-admin";

const AccountList = () => {

  return (
    <List
      sort={{ field: 'id', order: 'DESC' }}
    >
      <Datagrid>
        <TextField source="email" />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export default AccountList;
